import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TicketService } from '../services/ticket.service';
import { SpecialService } from '../services/special.service';
import { Ticket } from '../models/ticket.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'ticket',
  templateUrl: '../views/core/ticket.html',
  providers: [TicketService,SpecialService]
})
export class TicketComponent{
  public title: string;
  public tickets: Ticket[];
  public collectors:any[];
  public cfounds: any[];
  public submitTicketModel: Ticket;
  public txtSearch:string;
  public message: any;
  public mode: string;
  public searching:boolean;
  public collectorSelected:boolean;
  public contract_id:number;
  public customer_name:string;
  public wait:boolean;
  public contractPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private ticketService: TicketService,
    public sharedVariables: VariableService,
    public specialService: SpecialService
  )
  {
      this.title = null;
      this.mode = "submit-add";
      this.submitTicketModel = new Ticket(null,null,null,null,null,null,null,null);
      this.wait = true;
      this.contractPrivilege = null;
  }

  /*ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    if(this.sharedVariables.validSession()){
      this.getCollectors();
      this.getContractInformation();
      this.getAllTickets();
    }
    else
      this.title = "Error, Sesión no iniciada";
  }*/
  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.contractPrivilege == 1){
                                    this.getCollectors();
                                    this.getContractInformation();
                                    this.getAllTickets();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllTickets()
  {
    this.ticketService.getTicket(this.contract_id).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.tickets = result.data;
          console.log(this.tickets);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getCollectors()
  {
    this.specialService.getCollectors().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.collectors = result.data;
          console.log(this.collectors);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getContractInformation()
  {
    this._route.params.forEach((params: Params)=>{
      let id = params['id'];
      let customer_name = params['customer_name'];
      this.contract_id = id;
      this.customer_name = customer_name;
      this.submitTicketModel.Contract_ID = this.contract_id;
    });
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.saveTicket();
    }else{
      this.updateTicket();
    }
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllTickets();
                      this.submitTicketModel = new Ticket(null,null,null,null,null,null,null,null);
                      this.submitTicketModel.Contract_ID = this.contract_id;
                    },this.sharedVariables.timeToLoad);
    this.mode = "submit-add";
    console.log("mode",this.mode);
    this.txtSearch = null;
    this.collectorSelected = null;
  }

  saveTicket()
  {
    this.ticketService.addTicket(this.submitTicketModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  editTicket(pTicket: Ticket)
  {
    this.mode = "submit-update";
    this.submitTicketModel = Object.assign({}, pTicket);

    console.log("Checkout objects");
    console.log(this.submitTicketModel);
    console.log("mode",this.mode);
  }

  updateTicket()
  {
    /*this._route.params.forEach((params: Params)=>{*/
      let id = this.submitTicketModel.ID;
      console.log("objeto update ",this.submitTicketModel);
      this.ticketService.updateTicket(id,this.submitTicketModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
      /*});*/
  }

  deleteTicket(id: number)
  {
    this.ticketService.deleteTicket(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllTickets();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  cleanObject()
  {
    this.submitTicketModel = this.submitTicketModel = new Ticket(null,null,null,null,null,null,null,null);
  }
  showResultsCollectors(event: any) : void
  {
    console.log("event resultCollectors");
    if (event.target.value.length >= 3) {
      if(event.target.value.toLowerCase() != 'todos')
      {
        this.searching = true;
        this.cfounds = this.collectors.filter(collector => collector.name.match(event.target.value));
        console.log(this.cfounds);
      }
      else{
        this.cfounds = this.collectors;
      }
    } else {
      this.searching = false;
    }
  }
  chooseCollector(collector:any)
  {
    this.submitTicketModel.collector = collector.id;
    this.txtSearch = collector.name;
    this.collectorSelected = true;
    this.searching = false;
    console.log("submit model",this.submitTicketModel)
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.contractPrivilege = response.data[0].contract;
            console.log("Privilegios del usuario",this.contractPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/ticket.component.ts